import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column min-vh-100" }
const _hoisted_2 = {
  key: 0,
  class: "hompage-steps position-relative"
}
const _hoisted_3 = { class: "container container-fluid" }
const _hoisted_4 = { class: "row pt-5" }
const _hoisted_5 = {
  class: "col-md-4 position-relative",
  style: {"z-index":"100"}
}
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 1,
  src: "/images/mobile-steps.png"
}
const _hoisted_8 = { class: "col-md-8 pt-4" }
const _hoisted_9 = { class: "step mb-5" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h6", { class: "text-uppercase text-primary fw-bold" }, "Step 1", -1)
const _hoisted_11 = { class: "fw-bold" }
const _hoisted_12 = { class: "text-muted fw-normal" }
const _hoisted_13 = { class: "step mb-5" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h6", { class: "text-uppercase text-primary fw-bold" }, "Step 2", -1)
const _hoisted_15 = { class: "fw-bold" }
const _hoisted_16 = { class: "text-muted fw-normal" }
const _hoisted_17 = { class: "step mb-5" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h6", { class: "text-uppercase text-primary fw-bold" }, "Step 3", -1)
const _hoisted_19 = { class: "fw-bold" }
const _hoisted_20 = { class: "text-muted fw-normal" }
const _hoisted_21 = { class: "get-app-row primary-gradient-bg position-absolute start-0 w-100" }
const _hoisted_22 = { class: "container container-fluid" }
const _hoisted_23 = { class: "row py-4" }
const _hoisted_24 = { class: "offset-md-4 col-md-8" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("h5", { class: "text-white mb-3" }, "Get the App", -1)
const _hoisted_26 = { class: "list-inline" }
const _hoisted_27 = { class: "list-inline-item" }
const _hoisted_28 = ["href"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("img", {
  src: "/images/apple-store.png",
  height: "45"
}, null, -1)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = { class: "list-inline-item" }
const _hoisted_32 = ["href"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("img", {
  src: "/images/google-play.png",
  height: "45"
}, null, -1)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = { class: "featured-restaurants mb-5 pt-4" }
const _hoisted_36 = { class: "container container-fluid" }
const _hoisted_37 = { class: "d-flex justify-content-between mb-4" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("h4", { class: "main-section-title fw-bold" }, "Featured restaurants", -1)
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" See all ")
const _hoisted_40 = { class: "row" }
const _hoisted_41 = {
  key: 0,
  class: "col-lg-3 col-md-4 col-sm-6 mb-3"
}
const _hoisted_42 = { class: "card shadow-sm rounded-3 border-0" }
const _hoisted_43 = ["src", "alt"]
const _hoisted_44 = { class: "card-body px-3" }
const _hoisted_45 = {
  key: 0,
  class: "text-success fw-bold small mb-1"
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-circle availability" }, null, -1)
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" Available")
const _hoisted_48 = [
  _hoisted_46,
  _hoisted_47
]
const _hoisted_49 = {
  key: 1,
  class: "text-warning fw-bold small mb-1"
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-circle availability" }, null, -1)
const _hoisted_51 = /*#__PURE__*/_createTextVNode(" Limited Availabity")
const _hoisted_52 = [
  _hoisted_50,
  _hoisted_51
]
const _hoisted_53 = {
  key: 2,
  class: "text-secondary fw-bold small mb-1"
}
const _hoisted_54 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-circle availability" }, null, -1)
const _hoisted_55 = /*#__PURE__*/_createTextVNode(" Not Available")
const _hoisted_56 = [
  _hoisted_54,
  _hoisted_55
]
const _hoisted_57 = { class: "card-title fw-bold mb-1" }
const _hoisted_58 = { class: "text-muted" }
const _hoisted_59 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_60 = ["href"]
const _hoisted_61 = {
  class: "why-picado pb-5",
  id: "why-picado"
}
const _hoisted_62 = { class: "container container-fluid" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between mb-4" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "main-section-title fw-bold" }, "Why Picado?")
], -1)
const _hoisted_64 = { class: "row d-flex align-items-center" }
const _hoisted_65 = { class: "col-md-6" }
const _hoisted_66 = ["src"]
const _hoisted_67 = {
  key: 1,
  src: "/images/why-picado.png",
  alt: "Why Picado?",
  class: "w-100"
}
const _hoisted_68 = ["innerHTML"]
const _hoisted_69 = {
  class: "section-partners pb-5",
  id: "partners"
}
const _hoisted_70 = { class: "container container-fluid" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-5" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "fw-bold" }, "Our Partners")
], -1)
const _hoisted_72 = { class: "row pt-3" }
const _hoisted_73 = {
  id: "partnerSlider",
  class: "carousel slide partnerSlider",
  "data-bs-ride": "carousel",
  "data-bs-touch": "true",
  "data-bs-pause": "false",
  "data-bs-interval": "6000"
}
const _hoisted_74 = { class: "carousel-inner" }
const _hoisted_75 = { class: "slider-content row" }
const _hoisted_76 = ["href"]
const _hoisted_77 = ["src"]
const _hoisted_78 = { class: "text-muted mt-auto" }
const _hoisted_79 = /*#__PURE__*/_createStaticVNode("<button class=\"carousel-control-prev\" type=\"button\" data-bs-target=\"#partnerSlider\" data-bs-slide=\"prev\"><span class=\"carousel-control-prev-icon\" aria-hidden=\"true\"></span><span class=\"visually-hidden\">Previous</span></button><button class=\"carousel-control-next\" type=\"button\" data-bs-target=\"#partnerSlider\" data-bs-slide=\"next\"><span class=\"carousel-control-next-icon\" aria-hidden=\"true\"></span><span class=\"visually-hidden\">Next</span></button>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Slider = _resolveComponent("Slider")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header),
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(_component_Slider, { gallery: _ctx.gallery }, null, 8, ["gallery"])
    ], 512), [
      [_vShow, _ctx.gallery]
    ]),
    (_ctx.other_content)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (_ctx.other_content.steps_app_screenshot)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.other_content.steps_app_screenshot
                    }, null, 8, _hoisted_6))
                  : (_openBlock(), _createElementBlock("img", _hoisted_7))
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("h5", _hoisted_11, _toDisplayString(_ctx.other_content.steps_step1_title), 1),
                  _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.other_content.steps_steps_step1_text), 1)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("h5", _hoisted_15, _toDisplayString(_ctx.other_content.steps_step2_title), 1),
                  _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.other_content.steps_step2_text), 1)
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("h5", _hoisted_19, _toDisplayString(_ctx.other_content.steps_step3_title), 1),
                  _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.other_content.steps_step3_text), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createElementVNode("ul", _hoisted_26, [
                    _createElementVNode("li", _hoisted_27, [
                      _createElementVNode("a", {
                        href: _ctx.$store.state.configuration.ios_link,
                        class: "me-2",
                        target: "_blank"
                      }, _hoisted_30, 8, _hoisted_28)
                    ]),
                    _createElementVNode("li", _hoisted_31, [
                      _createElementVNode("a", {
                        href: _ctx.$store.state.configuration.android_link,
                        class: "me-3",
                        target: "_blank"
                      }, _hoisted_34, 8, _hoisted_32)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_35, [
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _hoisted_38,
          _createVNode(_component_router_link, {
            to: "/restaurants",
            class: "fw-bold mt-1 text-muted"
          }, {
            default: _withCtx(() => [
              _hoisted_39
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_40, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.featured_restaurants, (item, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: item.id
            }, [
              (index < 4)
                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("img", {
                        src: item.featured_photo_thumbnails.cover_small,
                        class: "card-img-top",
                        alt: item.name
                      }, null, 8, _hoisted_43),
                      _createElementVNode("div", _hoisted_44, [
                        (item.availabity_status == 'A')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_45, _hoisted_48))
                          : (item.availabity_status == 'LA')
                            ? (_openBlock(), _createElementBlock("p", _hoisted_49, _hoisted_52))
                            : (_openBlock(), _createElementBlock("p", _hoisted_53, _hoisted_56)),
                        _createElementVNode("h6", _hoisted_57, _toDisplayString(item.name), 1),
                        _createElementVNode("p", _hoisted_58, [
                          (item.cuisines && item.cuisines.length > 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(item.cuisines[0].name), 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _hoisted_59
                              ], 64))
                        ]),
                        _createElementVNode("a", {
                          href: _ctx.restaurantURL(item.id, item.name),
                          class: "btn btn-primary rounded-3 w-100 fw-bold"
                        }, "Book Now", 8, _hoisted_60)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_61, [
      _createElementVNode("div", _hoisted_62, [
        _hoisted_63,
        _createElementVNode("div", _hoisted_64, [
          _createElementVNode("div", _hoisted_65, [
            (_ctx.other_content && _ctx.other_content.why_image)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.other_content.why_image,
                  alt: "Why Picado?",
                  class: "w-100"
                }, null, 8, _hoisted_66))
              : (_openBlock(), _createElementBlock("img", _hoisted_67))
          ]),
          (_ctx.other_content)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "col-md-6",
                innerHTML: _ctx.other_content.why_text
              }, null, 8, _hoisted_68))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_69, [
      _createElementVNode("div", _hoisted_70, [
        _hoisted_71,
        _createElementVNode("div", _hoisted_72, [
          _createElementVNode("div", _hoisted_73, [
            _createElementVNode("div", _hoisted_74, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partners, (group, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["carousel-item", index == 0 ? 'active' : '']),
                  key: group
                }, [
                  _createElementVNode("div", _hoisted_75, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (item) => {
                      return (_openBlock(), _createElementBlock("a", {
                        class: "col-3 text-center d-block",
                        key: item.id,
                        href: item.link
                      }, [
                        _createElementVNode("img", {
                          src: item.logo
                        }, null, 8, _hoisted_77),
                        _createElementVNode("p", _hoisted_78, _toDisplayString(item.name), 1)
                      ], 8, _hoisted_76))
                    }), 128))
                  ])
                ], 2))
              }), 128))
            ]),
            _hoisted_79
          ])
        ])
      ])
    ]),
    _createVNode(_component_Footer)
  ]))
}